<template>
	<v-container fluid class="pt-0">
		<v-row>
			<v-col cols="12" xl="12" lg="12" md="12" class="mb-8">
				<v-card flat>
					<v-card-text>
						<v-card-title class="justify-center pa-2"> {{ $t('modules.otherCodebooks') }}</v-card-title>
						<v-row wrap>
							<v-flex md4 xs12>
								<v-col cols="12">
									<BasicObject
										:objectName="departments"
										:objectHeader="name"
										:title="titleDepartments"
									></BasicObject>
								</v-col>
							</v-flex>
							<v-flex md4 xs12>
								<v-col cols="12">
									<BasicObject
										:objectName="ranks"
										:objectHeader="name"
										:title="titleRanks"
									></BasicObject>
								</v-col>
							</v-flex>
							<v-flex md4 xs12>
								<v-col cols="12">
									<BasicObject
										:objectName="equipmentTypes"
										:objectHeader="name"
										:title="titleEquipmentTypes"
									></BasicObject>
								</v-col>
							</v-flex>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import BasicObject from './BasicObject';

export default {
	name: 'Codebooks',
	components: { BasicObject },
	data: function () {
		return {
			initialLoad: false,
			inEditMode: false,
			lockTimer: null,
			departments: 'departments',
			equipmentTypes: 'equipment-types',
			ranks: 'ranks',
			name: this.$t('fields.name'),
			titleRanks: this.$t('fields.ranks'),
			titleDepartments: this.$t('fields.departments'),
			titleEquipmentTypes: this.$t('fields.equipmentTypes'),
		};
	},
	methods: {
		backClick() {
			this.$router.go(-1);
		},
	},
	beforeRouteLeave(to, from, next) {
		if (this.inEditMode) {
			this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
				if (result) {
					next(true);
				} else {
					next(false);
				}
			});
		} else {
			next(true);
		}
	},
	mounted() {
		if (this.$myStore.state.user.user_role_id == 2) {
			this.$router.replace('/candidates');
		}

		let vm = this;

		this.$myStore.commit('setBreadcrumbs', [
			{
				text: vm.$t('modules.codebooks'),
				href: '/#/gantt',
				disabled: true,
			},
		]);
	},
};
</script>

<style scoped></style>
